"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ts = exports.onDisconnect = exports.off = exports.on = exports.list = exports.get = exports.once = exports.remove = exports.update = exports.push = exports.set = exports.eventType = void 0;

var _cache = _interopRequireDefault(require("./cache"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _construct(Parent, args, Class) { if (isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * Get the event string for Webcom from Reach events
 * @access protected
 * @param {string} event A Reach event
 * @return {string}
 */
var eventType = function eventType(event) {
  var evt;

  if (/_ADDED$/i.test(event) || /_PUBLISHED$/.test(event)) {
    evt = 'added';
  } else if (/_CHANGED$/.test(event) || /_REFRESHED$/.test(event)) {
    evt = 'changed';
  } else if (/_REMOVED$/.test(event) || /_UNPUBLISHED$/.test(event)) {
    evt = 'removed';
  }

  return evt ? "child_".concat(evt) : event;
};
/**
 * Write method
 * @param {string} method Write method (set,update)
 * @param {string} path The path to set
 * @param {object} data The data to set
 * @ignore
 */


exports.eventType = eventType;

var _write = function _write(method, path, data) {
  return new Promise(function (resolve, reject) {
    _cache.default.base.child(path)[method](data, function (error) {
      return error ? reject(error) : resolve();
    });
  });
};
/**
 * {@link Webcom#set} as a {@link Promise}
 * @access protected
 * @param {string} path The path to set
 * @param {object} data The data to set
 * @return {Promise<*, Error>}
 */


var set = _write.bind(undefined, 'set');
/**
 * {@link Webcom#push} as a {@link Promise}
 * @access protected
 * @param {string} path The path to push
 * @param {object} data The data to push
 * @return {Promise<Webcom, Error>}
 */


exports.set = set;

var push = function push(path, data) {
  return new Promise(function (resolve, reject) {
    var pushRef = _cache.default.base.child(path).push(data, function (error) {
      return error ? reject(error) : resolve(pushRef);
    });
  });
};
/**
 * {@link Webcom#update} as a {@link Promise}
 * @access protected
 * @param {string} path The path to update
 * @param {object} data The data to update
 * @return {Promise<*, Error>}
 */


exports.push = push;

var update = _write.bind(undefined, 'update');
/**
 * {@link Webcom#remove} as a {@link Promise}
 * @access protected
 * @param {string} path The path to remove
 * @return {Promise<*, Error>}
 */


exports.update = update;

var remove = function remove(path) {
  return new Promise(function (resolve, reject) {
    _cache.default.base.child(path).remove(function (error) {
      return error ? reject(error) : resolve();
    });
  });
};
/**
 * {@link Webcom#once} shortcut as a {@link Promise}
 * @access protected
 * @param {string} path The path
 * @param {string} event The event
 * @returns {Promise<Webcom/api.DataSnapshot, Error>}
 */


exports.remove = remove;

var once = function once(path, event) {
  return new Promise(function (resolve, reject) {
    _cache.default.base.child(path).once(eventType(event), resolve, reject);
  });
};
/**
 * {@link Webcom#once}('value') as a {@link Promise}
 * @access protected
 * @param {string} path The path to get
 * @return {Promise<Webcom/api.DataSnapshot, Error>}
 */


exports.once = once;

var get = function get(path) {
  return once(path, 'value');
};
/**
 * List values as a {@link Promise}
 * @access protected
 * @param {string} path The path to get
 * @param {function} Type The type of the object to list
 * @param params Additional constructor parameters
 * @return {Promise<Object[], Error>}
 */


exports.get = get;

var list = function list(path, Type) {
  for (var _len = arguments.length, params = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    params[_key - 2] = arguments[_key];
  }

  return get(path).then(function (snapData) {
    if (snapData) {
      var values = [];
      snapData.forEach(function (snapChild) {
        values.push(_construct(Type, [snapChild].concat(params)));
      });
      return values;
    }

    return [];
  });
};
/**
 * {@link Webcom#on} shortcut
 * @access protected
 * @param {string} path The path
 * @param {string} event The event
 * @param {Webcom/api.Query~queryCallback|function} queryCallback The callback
 * @param {Webcom/api.Query~cancelCallback|function} [cancelCallback] The callback
 */


exports.list = list;

var on = function on(path, event, queryCallback, cancelCallback) {
  _cache.default.base.child(path).on(eventType(event), queryCallback, cancelCallback);
};
/**
 * {@link Webcom#off} shortcut
 * @access protected
 * @param {string} path The path
 * @param {string} event The event
 * @param {function} [callback] The callback
 * @param {object} context The execution context
 */


exports.on = on;

var off = function off(path, event, callback) {
  _cache.default.base.child(path).off(eventType(event), callback);
};
/**
 * {@link Webcom#onDisconnect} shortcut
 * @access protected
 * @param {string} path The path
 * @return {Webcom/api.OnDisconnect}
 */


exports.off = off;

var onDisconnect = function onDisconnect(path) {
  return _cache.default.base.child(path).onDisconnect();
};
/**
 * Timestamp value
 * @access protected
 * @type {function}
 */
// export const ts = () => Webcom.ServerValue.TIMESTAMP;


exports.onDisconnect = onDisconnect;

var ts = function ts() {
  return Date.now();
}; // HACK #DataSync: Rollback when TIMESTAMP works again (server-side bug with security rules)


exports.ts = ts;